import { CommonModule } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule, ModalController } from '@ionic/angular';
import { NgxDatatableModule } from '@swimlane/ngx-datatable';

import { Automation } from 'src/models';
import { SharedPipesModule } from 'src/pipes/shared-pipes.module';
import { AuthService } from 'src/services/auth.service';
import { AutomationsService } from 'src/services/automations.service';
import { MessageService } from 'src/services/message.service';

@Component({
  standalone: true,
  imports: [CommonModule, FormsModule, IonicModule, NgxDatatableModule, SharedPipesModule, RouterModule],
  selector: 'app-automation-logs',
  templateUrl: './automation-logs.component.html',
  styleUrls: ['./automation-logs.component.scss'],
})
export class AutomationLogsComponent implements OnInit {
  runId: string;
  automationId: string | null = null;
  automation: Partial<Automation>;
  isLoading: boolean = false;
  hideMetadata = false;
  automationRunLogs: string[];

  constructor(
    public authService: AuthService,
    private modalCtrl: ModalController,
    private msgService: MessageService,
    private automationsService: AutomationsService,
  ) {}

  async ngOnInit() {
    this.getLogs();
  }

  async getLogs() {
    this.isLoading = true;
    this.automationRunLogs = [];

    const logs = await this.automationsService.listLogEntriesForRun(this.automationId, this.runId);

    this.automationRunLogs = logs.map((log) => {
      return this.hideMetadata
        ? log.message
        : `${log.severity === 'INFO' ? '✅' : '❌'} - ${log.timestamp} - ${log.message}`;
    });

    this.isLoading = false;
  }

  copyToClipboard() {
    const logsText = this.automationRunLogs.join('\n');
    navigator.clipboard.writeText(logsText);
    this.msgService.show('Copied');
  }

  dismiss() {
    this.modalCtrl.dismiss();
  }
}
